module.exports = __webpack_public_path__ + "img/bottom-back.eddf7bfe.png";